module.exports = __webpack_public_path__ + "static/media/noun_Handshake_540620.e8842f35.png";